import React, { useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { HeaderContainer, HeaderUserInfo, HeaderUserName, HeaderAdviserCode, HeaderUserOptions, HeaderUserOptionLine } from './styles';
import { BsBoxArrowRight } from 'react-icons/bs';
import Notifications from '../../components/Notifications';
import { HiOutlineUser } from 'react-icons/hi';
import colors from '../../assets/styles/colors';

const Header = ({ session, logout }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <HeaderContainer tabIndex={0} onBlur={() => setIsOpen(false)} id="header">
      <HeaderUserInfo open={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <HeaderUserName>{session?.name}</HeaderUserName>
        { session?.CodigoAsesor && (<HeaderAdviserCode>(Cod. Asesor: {session?.CodigoAsesor})</HeaderAdviserCode>) }
        <BsChevronDown color={colors.textPrimary} size={12} />
      </HeaderUserInfo>
      <HeaderUserOptions open={isOpen}>
        <HeaderUserOptionLine>
          <HiOutlineUser size={20} color={colors.textPrimary} />
          Perfil
        </HeaderUserOptionLine>
        <HeaderUserOptionLine onClick={() => logout()}>
          <BsBoxArrowRight size={20} color={colors.textPrimary} id="arrow-right-icon" />
          Logout
        </HeaderUserOptionLine>
      </HeaderUserOptions>
      <Notifications />
    </HeaderContainer>
  )
}

export default Header;
